import React from 'react';
import ButtonCancel from '../Button/I';
import ButtonBlack from '../Button/Black';
import Popup from './A';


module.exports = (props) => {
  const {
    onCancel,
    onSave,
    text,
    disabled,
    beforeButtons,
  } = props;
  return (
    <Popup className={props.className || ''}>
      <div className="layoutRow fhaS fvaC">
        <div className="f23 fw7 lh fx1 wmin0">
          {props.caption || ''}
        </div>
      </div>

      {props.children}

      {(onCancel || onSave) && (
        <div className="mt30">
          <div className="layoutRow fhaE fvaC">
            {beforeButtons || null}
            {onCancel ? (
              <div className="pl15 mv-10 mr-15">
                <ButtonCancel
                  onClick={onCancel}
                >
                  <div className="layoutRow fhaC fvaC rlv st1 w170">
                    <div>Cancel</div>
                  </div>
                </ButtonCancel>
              </div>
            ) : null}

            {onSave ? (
              <div className="pl15 mv-10 mr-15 ml10">
                <ButtonBlack
                  disabled={disabled}
                  onClick={onSave}
                >
                  <div className="layoutRow fhaC fvaC rlv st1 w170">
                    <div>{text || 'Save'}</div>
                  </div>
                </ButtonBlack>
              </div>
            ) : null}
          </div>
        </div>
      )}
    </Popup>
  );
};
